import { ApiClientImplementation } from 'infra/api-client/api-client'
import { PrepareApiRequestDecorator } from 'main/decorators/prepare-api-request-decorator/prepare-api-request-decorator'
import { makeLocalStorageAdapter } from 'main/factories/cache/local-storage-adapter-factory'
import SurgicalPendencyService from 'presentation/contexts/services/surgical-pendency-service'
import { ApiRepository } from 'repository/api-repository'
import { SurgicalPendencyRepository } from 'repository/repositories/surgical-pendency/surgical-pendency-repository'
import { RemoteAnswerSurgicalPendency } from 'service/usecases/answer-surgical-pendency/remote-answer-surgical-pendency'
import { RemoteLoadSurgicalOrderTimeLine } from 'service/usecases/load-surgical-order-time-line/remote-load-surgical-order-time-line'
import { RemoteLoadSurgicalPendency } from 'service/usecases/load-surgical-pendency/remote-load-surgical-pendency'
import { RemoteUploadSurgicalPendencyDocument } from 'service/usecases/upload-surgical-pendency-document/remote-upload-surgical-pendency-document'
import { RemoteLoadSurgicalPendencyDocument } from 'service/usecases/load-surgical-pendency-document/remote-load-surgical-pendency-document'
import { RemoteLoadSurgicalPendencyHistory } from 'service/usecases/load-surgical-pendency-history/remote-load-surgical-pendency-history'
import { RemoteLoadSurgicalOrderNoticeCard } from 'service/usecases/load-surgical-order-notice-card/remote-load-surgical-order-notice-card'
import { RemoteAddSurgicalPendency } from 'service/usecases/add-surgical-pendency/remote-add-surgical-pendency'
import { RemoteFinishSurgicalPendency } from 'service/usecases/finish-surgical-pendency/remote-finish-surgical-pendency'
import { RemoteLoadHelpPendencyHistory } from 'service/usecases/load-help-pendency-history/load-help-pendency-history'
import { RemoteCreateHelpPendencyMessage } from 'service/usecases/create-help-pendency-message/remote-create-help-pendency-message'
import { RemoteFinishHelpPEndency } from 'service/usecases/finish-help-pendency/remote-finish-help-pendency'
import { RemoteLoadAuthorizedCommunicationHistory } from 'service/usecases/load-authorized-communication-history/load-authorized-communication-history'
import { RemoteCreateAuthorizedCommunicationMessage } from 'service/usecases/create-authorized-communication-message/remote-create-authorized-communication-message'
import { RemoteFinishAuthorizedCommunication } from 'service/usecases/finish-authorized-communication/remote-finish-authorized-communication'
import { RemoteAnswerDoctorCommunication } from 'service/usecases/answer-doctor-communication/remote-answer-doctor-communication'

export default function makeSurgicalPendencyService() {
  const apiRepository = new PrepareApiRequestDecorator(
    makeLocalStorageAdapter(),
    new ApiRepository(new ApiClientImplementation())
  )

  const surgicalPendencyRepository = new SurgicalPendencyRepository(
    apiRepository
  )

  const answerSurgicalPendency = new RemoteAnswerSurgicalPendency(
    surgicalPendencyRepository
  )
  const uploadSurgicalPendencyDocument =
    new RemoteUploadSurgicalPendencyDocument(surgicalPendencyRepository)

  const loadSurgicalPendencyDocument = new RemoteLoadSurgicalPendencyDocument(
    surgicalPendencyRepository
  )

  const loadSurgicalPendency = new RemoteLoadSurgicalPendency(
    surgicalPendencyRepository
  )

  const loadSurgicalOrderTimeLine = new RemoteLoadSurgicalOrderTimeLine(
    surgicalPendencyRepository
  )

  const loadSurgicalPendencyHistory = new RemoteLoadSurgicalPendencyHistory(
    surgicalPendencyRepository
  )

  const loadSurgicalOrderNoticeCard = new RemoteLoadSurgicalOrderNoticeCard(
    surgicalPendencyRepository
  )

  const addSurgicalPendency = new RemoteAddSurgicalPendency(
    surgicalPendencyRepository
  )

  const loadHelpPendencyHistory = new RemoteLoadHelpPendencyHistory(
    surgicalPendencyRepository
  )

  const createHelpPendencyMessage = new RemoteCreateHelpPendencyMessage(
    surgicalPendencyRepository
  )

  const finishHelpPendency = new RemoteFinishHelpPEndency(
    surgicalPendencyRepository
  )

  const finishSurgicalPendency = new RemoteFinishSurgicalPendency(
    surgicalPendencyRepository
  )

  const loadAuthorizedCommunicationHistory =
    new RemoteLoadAuthorizedCommunicationHistory(surgicalPendencyRepository)

  const createAuthorizedCommunicationMessage =
    new RemoteCreateAuthorizedCommunicationMessage(surgicalPendencyRepository)

  const finishAuthorizedCommunication = new RemoteFinishAuthorizedCommunication(
    surgicalPendencyRepository
  )

  const answerDoctorCommunication = new RemoteAnswerDoctorCommunication(
    surgicalPendencyRepository
  )

  return new SurgicalPendencyService({
    answerSurgicalPendency,
    uploadSurgicalPendencyDocument,
    loadSurgicalPendencyDocument,
    loadSurgicalPendency,
    loadSurgicalOrderTimeLine,
    loadSurgicalPendencyHistory,
    loadHelpPendencyHistory,
    createHelpPendencyMessage,
    loadSurgicalOrderNoticeCard,
    addSurgicalPendency,
    finishSurgicalPendency,
    finishHelpPendency,
    loadAuthorizedCommunicationHistory,
    createAuthorizedCommunicationMessage,
    finishAuthorizedCommunication,
    answerDoctorCommunication
  })
}
